import script from "./TimeStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeStatus.vue?vue&type=script&setup=true&lang=js"

export default script